<template>
  <div class="d-flex-column justify-start align-start gap-40">
    <MmoPackDetail class="small_bg_2" v-if="!$isMobile() && !$isTablet()" />

    <HonorPicker />

    <!-- <div
      class="d-flex-column justify-start align-start gap-24"
      v-if="!$isMobile() && !$isTablet()"
    >
      <template v-for="key in keys">
        <div
          class="pack_text_detail"
          v-html="getGamePack?.pack_description_detail[key]"
        ></div>
      </template>
    </div> -->
  </div>
</template>

<script setup>
import HonorPicker from "./pickers/HonorPick.vue";
import MmoPackDetail from "./pickers/MmoPackDetail.vue";
import ServerPicker from "./pickers/ServerPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import { computed, ref, onMounted } from "vue";

const { getGame, getGamePack } = useGameStore();
const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  const account_sharing = getGamePack?.pack_options?.find(
    (op) => op.const_title === "account_sharing"
  );
  const standard = getGamePack?.pack_options?.find(
    (op) => op.const_title === "standard"
  );

  checkoutStore.clearCheckout();

  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    desiredHonour: 60000,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
  if (account_sharing) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, account_sharing.id],
    });
  }
  if (standard) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, standard.id],
    });
  }
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
